import React from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App";
// Tokens first so the app stylesheet (tailwind layers) can build on them.
import "@app/shared/src/components_v2/tokens.css";
import "./index.css";

const container = document.getElementById("root");
if (!container) {
    throw new Error("Root element not found");
}

createRoot(container).render(
    <React.StrictMode>
        <App />
    </React.StrictMode>,
);
